import React, { Component } from 'react';
import { hot } from 'react-hot-loader';
import { connect } from 'react-redux';
import Pagination from '../Pagination/Pagination';
import { updateFilter, resetFilter, clearFilter, updatePagination } from '../../actions/environment';
import { intersect, unique } from '../../utils/array';
import { translate, prefix } from '../../utils/locale';
import { deepCompare } from '../../utils/object';
import s from './Filter.scss';

class Filter extends Component {
	constructor(props) {
		super(props);

		this.state = {
			filterOpen: false,
			sortOpen: false,
			categories: false,
			colors: false,
			materials: false,
			hash: typeof window !== 'undefined' ? window.location.hash : '',
		};

		this.filterTools = React.createRef();
	}

	componentDidMount() {
		if (this.state.hash) {
			const hashFilter = [];
			this.state.hash.slice(1).split('&').forEach((filterPart) => {
				const filterParts = filterPart.split('=');
				if (filterParts.length === 1) {
					hashFilter.push({ [filterParts[0]]: true });
				} else {
					hashFilter.push({ [filterParts[0]]: filterParts[1].split(',') });
				}
			});

			this.props.updateFilter(hashFilter, true, this.props.setup, this.props.currentPath);
			this.setState({ hash: null });
		}
	}

	handleToggleDropdown = (e) => {
		e.preventDefault();
		const $link = e.currentTarget;

		const changeFilterState = () => {
			if ($link.getAttribute('href') === '#open-filter') {
				this.setState((prevState) => ({
					filterOpen: !prevState.filterOpen,
					sortOpen: false,
				}));
			} else {
				this.setState((prevState) => ({
					sortOpen: !prevState.sortOpen,
					filterOpen: false,
				}));
			}
		};

		changeFilterState();
	}

	handleClearFilter = (e) => {
		e.preventDefault();
		this.props.clearFilter();
		this.props.updatePagination(this.props.currentPath, 1);
	}

	handleToggleGroup = (e) => {
		e.preventDefault();
		const $link = e.currentTarget;
		const whichGroup = $link.dataset.group;

		this.setState((prevState) => ({
			[whichGroup]: prevState[whichGroup] ? !prevState[whichGroup] : true,
		}));
	}

	handleFilterUpdate = (e) => {
		e.preventDefault();
		const $link = e.currentTarget;
		const action = $link.getAttribute('href');
		const filterType = action.indexOf('#') === 0 ? action.slice(1, action.indexOf('=')) : 'categories';
		const filterValue = action.indexOf('#') === 0 ? action.slice(action.indexOf('=') + 1) : action.replace(prefix(this.props.setup, ''), '');

		this.props.updateFilter([{ [filterType]: filterValue }], false, this.props.setup, this.props.currentPath);
		this.props.updatePagination(this.props.currentPath, 1);

		if (filterType === 'sort') {
			this.setState({
				sortOpen: false,
			});
		}
	}

	render() {
		const { ListComponent, location, data, filtering, setup, filter, currentPath, contentSections } = this.props;
		const { filterOpen, sortOpen } = this.state;

		// how to update filterHash on page load???

		const { filterArrays, filterDescriptions, localized, products } = filtering;
		const isLocalized = localized[setup.language];
		const isFiltered = !deepCompare(filter.clearFilterBase, filter.filteredBy);

		if (!filter.currentFilterSegment) return null;

		// Category paths are localized.
		const categories = isLocalized ? Object.keys(filterArrays.categories).reduce((acc, category) => {
			const categoryKey = isLocalized.categories[category] ? isLocalized.categories[category].key : category;
			return ({ ...acc, [categoryKey]: [...filterArrays.categories[category]] });
		}, {}) : filterArrays.categories;

		// Localize categories
		const categoryTitles = isLocalized ? Object.keys(filterArrays.categories).reduce((acc, category) => {
			const categoryKey = isLocalized.categories[category] ? isLocalized.categories[category].key : category;
			const categoryDescription = isLocalized.categories[category] ? isLocalized.categories[category].description : filterDescriptions.categories[category];
			return ({ ...acc, [categoryKey]: categoryDescription });
		}, {}) : filterDescriptions.categories;

		// Categories that use base path.
		const relevantCategories = filter.currentFilterSegment === 'all' ? { ...categories } : Object.keys(categories).reduce((acc, category) => (category.indexOf(filter.currentFilterSegment) === 0 ? { ...acc, [category]: [...categories[category]] } : acc), {});

		// Localize colors
		const colors = isLocalized ? Object.keys(filterArrays.colors).reduce((acc, color) => {
			const colorkey = isLocalized.colors[color] ? isLocalized.colors[color].key : color;
			return ({ ...acc, [colorkey]: [...filterArrays.colors[color]] });
		}, {}) : filterArrays.colors;

		const colorDescriptions = isLocalized ? Object.keys(filterArrays.colors).reduce((acc, color) => {
			const colorKey = isLocalized.colors[color] ? isLocalized.colors[color].key : color;
			const colorDescription = isLocalized.colors[color] ? isLocalized.colors[color].description : filterDescriptions.colors[color];
			return ({ ...acc, [colorKey]: colorDescription });
		}, {}) : filterDescriptions.colors;

		// Localize materials
		const materials = isLocalized ? Object.keys(filterArrays.materials).reduce((acc, material) => {
			const materialkey = isLocalized.materials[material] ? isLocalized.materials[material].key : material;
			return ({ ...acc, [materialkey]: [...filterArrays.materials[material]] });
		}, {}) : filterArrays.materials;

		const materialDescriptions = isLocalized ? Object.keys(filterArrays.materials).reduce((acc, material) => {
			const materialKey = isLocalized.materials[material] ? isLocalized.materials[material].key : material;
			const materialDescription = isLocalized.materials[material] ? isLocalized.materials[material].description : filterDescriptions.materials[material];
			return ({ ...acc, [materialKey]: materialDescription });
		}, {}) : filterDescriptions.materials;

		/*
			Filter

			This could benefit from memoization - reselect

			Filters which don't match the base list of products are removed i.e. women men etc.
			Filters which don't match the current categories' list of products are disabled. Except categories.
		*/

		// Get base URI for filtering.
		if (data.baseUri === undefined) return null;

		let relevantBaseProducts = data.baseType === 'campaigns' ? filterArrays[data.campaignType] : filterArrays[data.baseType][data.baseUri];
		if (relevantBaseProducts === undefined) relevantBaseProducts = [];
		relevantBaseProducts = relevantBaseProducts.filter((rbp) => products[rbp] !== undefined);
		let relevantProducts = [...relevantBaseProducts];

		const filteredProducts = {};

		// Filter only relevant products
		filter.filteredBy.forEach((filterObj) => {
			const filterType = Object.keys(filterObj)[0];
			const filterItem = filterObj[filterType];
			if (filterItem === true || (Array.isArray(filterItem) && filterItem.length > 0)) {
				// Products are filtered
				// Need to update relevantProducts on every pass.
				switch (filterType) {
					case 'categories': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...(categories[type] ? categories[type] : []), ...acc], []));
						filteredProducts.categories = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
						break;
					}
					case 'colors': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...colors[type], ...acc], []));
						filteredProducts.colors = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
					}
						break;
					case 'materials': {
						const concatenatedItems = unique(filterItem.reduce((acc, type) => [...materials[type], ...acc], []));
						filteredProducts.materials = concatenatedItems;
						relevantProducts = intersect(relevantProducts, concatenatedItems);
					}
						break;
					default:
						break;
				}
			}
		});

		// Last filter is special so that the user can select multiple filters.
		let relevantFilterProductsCat = [...relevantBaseProducts];
		let relevantFilterProductsLastCat = [...relevantBaseProducts];
		let lastFilter = '';

		// Restrict filters based on final filter in filteredBy.
		filter.filteredBy.slice(1).forEach((filterObj, i) => {
			lastFilter = Object.keys(filterObj)[0];
			relevantFilterProductsCat = intersect(relevantFilterProductsCat, filteredProducts[lastFilter]);
			if (i < filter.filteredBy.length - 2) relevantFilterProductsLastCat = intersect(relevantFilterProductsLastCat, filteredProducts[lastFilter]);
		});

		let relevantFilterProducts = [...relevantBaseProducts];
		let relevantFilterProductsLast = [...relevantBaseProducts];

		// Restrict filters based on final filter in filteredBy.
		filter.filteredBy.slice(0).forEach((filterObj, i) => {
			lastFilter = Object.keys(filterObj)[0];
			relevantFilterProducts = intersect(relevantFilterProducts, filteredProducts[lastFilter]);
			if (i < filter.filteredBy.length - 1) relevantFilterProductsLast = intersect(relevantFilterProductsLast, filteredProducts[lastFilter]);
		});

		/*
			Sorting
		*/
		if (filter.sort) {
			const sortBy = filter.sort.replace(/-(ascending|descending)$/, '');

			relevantProducts = relevantProducts.map((productId) => {
				let sortingValue = filter.sort.indexOf('descending') !== -1 ? 0 : 9999999999;
				if (products[productId].inStock === 0) return { key: productId, sort: sortingValue };

				if (sortBy === 'price') {
					sortingValue = products[productId].price.priceAsNumber;
				} else if (products[productId][sortBy]) {
					sortingValue = products[productId][sortBy];
				}
				return { key: productId, sort: sortingValue };
			}).sort((a, b) => {
				if (a.sort === b.sort) return parseInt(a.key, 10) > parseInt(b.key, 10) ? 1 : -1;
				if (filter.sort.indexOf('descending') === -1) {
					return a.sort > b.sort ? 1 : -1;
				}
				return a.sort < b.sort ? 1 : -1;
			}).map((productObject) => productObject.key);
		}

		/*
			Class manipulation
		*/
		const filterToolsClass = [s.filter_tools];
		if (relevantBaseProducts.length === 0) filterToolsClass.push(s.filter_tools__empty);

		const filterClasses = [s.filtering];
		if (filterOpen) filterClasses.push(s.filtering__open);

		const sortClasses = [s.filtering];
		if (sortOpen) sortClasses.push(s.filtering__open);

		const categoryGroupClasses = [s.filtering_section_group];
		if (this.state.categories) categoryGroupClasses.push(s.filtering_section_group__open);

		const colorGroupClasses = [s.filtering_section_group];
		if (this.state.colors) colorGroupClasses.push(s.filtering_section_group__open);

		const materialGroupClasses = [s.filtering_section_group];
		if (this.state.materials) materialGroupClasses.push(s.filtering_section_group__open);

		const categoryFilters = Object.keys(relevantCategories).filter((categoryLevel1) => {
			if (categoryLevel1.split('/').length !== filter.currentFilterSegment.split('/').length + 1) return false;
			if (intersect(relevantCategories[categoryLevel1], relevantBaseProducts).length === 0) return false;
			return true;
		});

		return (
			<div className={s.filter}>
				<div className={filterToolsClass.join(' ')} ref={this.filterTools}>
					<div className={filterClasses.join(' ')}>
						<a className={s.filtering_title} href="#open-filter" onClick={this.handleToggleDropdown}><span>{ translate(setup, 'filter') }</span></a>
						{ isFiltered ? <a className={s.filtering_clear} href="#clear-filter" onClick={this.handleClearFilter}>{ translate(setup, 'filterClear') }</a> : null }
						<div className={s.filtering_inner}>
							<div className={s.filtering_section}>
								{/* Colors */}
								<div className={colorGroupClasses.join(' ')}>
									<a className={s.filtering_section_group_title} href="#open-group" data-group="colors" onClick={this.handleToggleGroup}>{ translate(setup, 'filterColor') }</a>
									<div className={s.filtering_section_group_inner}>
										{
											Object.keys(colors).sort((a, b) => (parseInt(colorDescriptions[a].order, 10) > parseInt(colorDescriptions[b].order, 10) ? 1 : -1)).map((color) => {
												if (intersect(colors[color], relevantBaseProducts).length === 0) return null;

												const linkClasses = [s.filtering_section_color];
												if (intersect(colors[color], (lastFilter === 'colors' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.filtering_section_color__disabled);
												if (filter.colors.indexOf(color) !== -1) linkClasses.push(s.filtering_section_color__selected);

												return <a key={color} onClick={this.handleFilterUpdate} className={linkClasses.join(' ')} href={`#colors=${color}`} aria-labelledby={colorDescriptions[color].desc}><span style={{ backgroundColor: colorDescriptions[color].hex }} /></a>;
											})
										}
									</div>
								</div>
							</div>
							<div className={s.filtering_section}>
								{/* Materials */}
								<div className={materialGroupClasses.join(' ')}>
									<a className={s.filtering_section_group_title} href="#open-group" data-group="materials" onClick={this.handleToggleGroup}>{ translate(setup, 'filterMaterial') }</a>
									<div className={s.filtering_section_group_inner}>
										{
											Object.keys(materials).sort().map((material) => {
												if (intersect(materials[material], relevantBaseProducts).length === 0) return null;

												const linkClasses = [s.filtering_section_link];
												if (intersect(materials[material], (lastFilter === 'materials' ? relevantFilterProductsLast : relevantFilterProducts)).length === 0) linkClasses.push(s.filtering_section_link__disabled);
												if (filter.materials.indexOf(material) !== -1) linkClasses.push(s.filtering_section_link__selected);

												return <a key={material} onClick={this.handleFilterUpdate} className={linkClasses.join(' ')} href={`#materials=${material}`}><span>{ materialDescriptions[material] }</span></a>;
											})
										}
									</div>
								</div>
							</div>
							{
								categoryFilters.length > 0 && (
									<div className={s.filtering_section}>
										{/* Categories */}
										<div className={categoryGroupClasses.join(' ')}>
											<a className={s.filtering_section_group_title} href="#open-group" data-group="categories" onClick={this.handleToggleGroup}>{ translate(setup, 'filterCategory') }</a>
											<div className={s.filtering_section_group_inner}>
												{
													categoryFilters.map((categoryLevel1) => {
														const linkClasses = [s.filtering_section_link];
														if (filter.categories.indexOf(categoryLevel1) !== -1) linkClasses.push(s.filtering_section_link__selected);

														return <a key={categoryLevel1} onClick={this.handleFilterUpdate} className={linkClasses.join(' ')} href={prefix(setup, categoryLevel1)}><span>{ categoryTitles[categoryLevel1] }</span></a>;
													})
												}
											</div>
										</div>
									</div>
								)
							}
						</div>
						<div className={s.sorting_inner}>
							<span className={s.sorting_inner_title}>{ translate(setup, 'sort') }</span>
							<a onClick={this.handleFilterUpdate} className={[s.filtering_section_link, ...(filter.sort === 'added-descending' ? [s.filtering_section_link__selected] : [])].join(' ')} href="#sort=added-descending">{ translate(setup, 'sortNewest') }</a>
							<a onClick={this.handleFilterUpdate} className={[s.filtering_section_link, ...(filter.sort === 'price-ascending' ? [s.filtering_section_link__selected] : [])].join(' ')} href="#sort=price-ascending">{ translate(setup, 'sortCheapest') }</a>
							<a onClick={this.handleFilterUpdate} className={[s.filtering_section_link, ...(filter.sort === 'price-descending' ? [s.filtering_section_link__selected] : [])].join(' ')} href="#sort=price-descending">{ translate(setup, 'sortMostExpensive') }</a>
						</div>
					</div>
				</div>
				{
					relevantProducts.length > 0 ? (
						<Pagination ListComponent={ListComponent} list={relevantProducts} cache={products} currentPath={prefix(setup, currentPath)} currentHash="" showAll={location.query && location.query.showAll !== undefined} contentSections={contentSections} />
					) : (
						<div className={s.filter_empty}>
							<h1 className={s.filter_empty_title}>{ relevantBaseProducts.length > 0 ? translate(setup, 'filterNoResults') : translate(setup, 'filterNoResultsNoFilter') }</h1>
							{
								filter.filteredBy.map((filterObj) => (
									Object.keys(filterObj).map((filterKey) => {
										if (Array.isArray(filterObj[filterKey])) {
											return filterObj[filterKey].map((filterItem) => {
												if (filterKey === 'categories') {
													return <a className={s.filter_empty_link} href={prefix(setup, filterItem)} onClick={this.handleFilterUpdate}>{ categoryTitles[filterItem] }</a>;
												}
												let title = filterDescriptions[filterKey][filterItem];
												if (filterKey === 'colors') title = colorDescriptions[filterItem];
												if (filterKey === 'materials') title = materialDescriptions[filterItem];
												return <a className={s.filter_empty_link} href={`#${filterKey}=${filterItem}`} onClick={this.handleFilterUpdate}>{ title }</a>;
											});
										}
										return <a className={s.filter_empty_link} href={`#${filterKey}=1`} onClick={this.handleFilterUpdate}>{ translate(setup, `filter${filterKey.charAt(0).toUpperCase()}${filterKey.slice(1)}`) }</a>;
									})
								))
							}
						</div>
					)
				}
			</div>
		);
	}
}

const mapState = ({ filter, location }, { ListComponent, data, filtering, setup, currentPath, productUri = false }) => ({
	filter,
	location,
	ListComponent,
	data,
	filtering,
	setup,
	currentPath,
	productUri,
});

export default hot(module)(connect(mapState, { updateFilter, resetFilter, clearFilter, updatePagination })(Filter));
